"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TextInputLabel;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["inputId", "value", "required", "invalid", "floats", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function TextInputLabel(_ref) {
  var inputId = _ref.inputId,
    value = _ref.value,
    required = _ref.required,
    invalid = _ref.invalid,
    floats = _ref.floats,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("label", _extends({}, rest, {
    htmlFor: inputId,
    className: (0, _classnames["default"])('rrui__input-label', {
      'rrui__input-label--required': required && isEmptyOrBlank(value),
      'rrui__input-label--required-field': required,
      'rrui__input-label--invalid': invalid,
      'rrui__input-label--floating': floats,
      'rrui__text-input__label--placeholder': floats && isEmptyOrBlank(value)
    })
  }), children);
}
function isEmptyOrBlank(value) {
  // Whitespace strings are considered empty.
  if (typeof value === 'string') {
    return !value || !value.trim();
  }
  return value === undefined || value === null;
}
//# sourceMappingURL=TextInputLabel.js.map